import { render, staticRenderFns } from "./BankReconciliation.vue?vue&type=template&id=4b540a07&scoped=true"
import script from "./BankReconciliation.vue?vue&type=script&lang=js"
export * from "./BankReconciliation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b540a07",
  null
  
)

export default component.exports